"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nLanguageProvider = exports.I18nLanguageContext = void 0;
var client_1 = require("@apollo/client");
var i18next_1 = __importDefault(require("i18next"));
var lodash_1 = require("lodash");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var queries_1 = require("../components/LanguageSelector/Graphql/queries");
var localStorage_1 = __importDefault(require("../config/localStorage"));
exports.I18nLanguageContext = react_1.default.createContext({
    newI18n: i18next_1.default,
    languages: {},
    updateI18n: function () { },
});
var I18nLanguageProvider = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)(), languages = _b[0], setLanguages = _b[1];
    var _c = (0, client_1.useLazyQuery)(queries_1.GET_LANGUAGE_WITH_TRANSLATION), callLanguageTranslation = _c[0], responseLanguageTranslation = _c[1];
    (0, react_1.useEffect)(function () {
        assembleLanguage();
    }, []);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if ((_a = responseLanguageTranslation === null || responseLanguageTranslation === void 0 ? void 0 : responseLanguageTranslation.data) === null || _a === void 0 ? void 0 : _a.getLanguageWithTranslation) {
            translateResources((_b = responseLanguageTranslation === null || responseLanguageTranslation === void 0 ? void 0 : responseLanguageTranslation.data) === null || _b === void 0 ? void 0 : _b.getLanguageWithTranslation);
        }
    }, [responseLanguageTranslation]);
    var translateResources = function (getData) {
        var langArray = {};
        if (getData && getData.length > 0) {
            getData.map(function (item) {
                var temp = {
                    label: item.label,
                    value: item.code,
                    translation: JSON.parse(item.translation),
                };
                langArray[temp.value] = temp;
            });
        }
        setLanguages(langArray);
        if (!(0, lodash_1.isEmpty)(langArray)) {
            i18next_1.default
                .use(react_i18next_1.initReactI18next) // passes i18n down to react-i18next
                .init({
                compatibilityJSON: "v3",
                resources: langArray,
                // returnNull: false,
                fallbackLng: "EN",
                lng: "EN",
                keySeparator: false,
                interpolation: {
                    escapeValue: false, // react already safes from xss
                },
            }, function (err) {
                if (err) {
                    return console.log("something went wrong:", err);
                }
            });
        }
    };
    var assembleLanguage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var selectedCountry;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, localStorage_1.default.getItem("country")];
                case 1:
                    selectedCountry = _a.sent();
                    callLanguageTranslation({
                        variables: { country_code: selectedCountry || "BI" },
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(exports.I18nLanguageContext.Provider, { value: {
            newI18n: i18next_1.default,
            languages: languages != undefined && languages,
            updateI18n: assembleLanguage,
        } }, children));
};
exports.I18nLanguageProvider = I18nLanguageProvider;
